var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-headful',{attrs:{"title":`Write for me!`,"description":`Latest events`}}),_c('v-row',[_c('v-col',[_c('event-list')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }